import React, { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '@/ui/index';

import styles from './RecordModal.module.scss';

const RecognitionWebcam = ({
  children,
  capturing,
  progress,
  handleStartRecognition,
}) => {
  const { t } = useTranslation();

  const [delayButtonActive, setDelayButtonActive] = useState(true);
  const [cameraAccess, setCameraAccess] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setDelayButtonActive(false);
    }, 3000);
  }, []);

  useEffect(() => {
    const accessCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        setCameraAccess(true);
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        setCameraAccess(false);
      }
    };

    accessCamera();
  }, []);

  return (
    <div
      className={styles.faceInfoContent}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <div>{children}</div>
      {capturing && (
        <progress
          className={styles.face_progress_bar}
          value={progress}
          max={100}
        />
      )}
      <div className={styles.btn_groups}>
        <Button
          onClick={handleStartRecognition}
          disabled={capturing || delayButtonActive || !cameraAccess}
          className={styles.start_face_btn}
        >
          {t('esim:recognitionInfo.start')}
        </Button>
      </div>
    </div>
  );
};

export default RecognitionWebcam;
